if (!customElements.get('purchase-vertical-story')) {
  customElements.define('purchase-vertical-story', class PurchaseVerticalStory extends HTMLElement {
    constructor() {
      super();
      this.animationFrame = null;
      this.ticking = false;
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.updatePinnedState = this.updatePinnedState.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.purchase-vertical-story');
      this.secondScreen = this.querySelector('.purchase-vertical-story__screen--text-left-image-right');
      this.thirdScreen = this.querySelector('.purchase-vertical-story__screen--full-overlay');

      if (!this.section || !this.secondScreen || !this.thirdScreen) {
        return;
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      if (this.desktopQuery.addEventListener) {
        this.desktopQuery.addEventListener('change', this.handleResize);
      }

      this.updatePinnedState();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.desktopQuery.removeEventListener) {
        this.desktopQuery.removeEventListener('change', this.handleResize);
      }

      if (this.animationFrame) {
        window.cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
      }

      if (this.section) {
        this.section.classList.remove('is-third-pinned');
      }
    }

    handleResize() {
      this.requestUpdate();
    }

    handleScroll() {
      this.requestUpdate();
    }

    requestUpdate() {
      if (this.ticking) {
        return;
      }

      this.ticking = true;
      this.animationFrame = window.requestAnimationFrame(this.updatePinnedState);
    }

    updatePinnedState() {
      this.ticking = false;
      this.animationFrame = null;

      if (!this.desktopQuery.matches) {
        this.section.classList.remove('is-third-pinned');
        return;
      }

      const secondRect = this.secondScreen.getBoundingClientRect();
      const shouldPinThird = secondRect.top <= 0 && secondRect.bottom > 0;

      this.section.classList.toggle('is-third-pinned', shouldPinThird);
    }
  });
}